import { useToast } from '@cad-arc';
import { useMemo } from 'react';
import { useApplicationType } from '../common/hooks/use-application-type';
import { useDispatchAreaStore } from '../dispatch-areas/use-dispatch-areas';
import { useDrawerControls } from '../drawers/components/drawer-context-provider';
import { electronBridge } from '../electron-bridge/electron-bridge';
import { createStreamListener, useStream } from '../socket/use-stream';

export function ResourceRecommendationsListener() {
    const { isWeb } = useApplicationType();
    const toast = useToast();
    const drawerControls = useDrawerControls();
    const dispatchAreasStore = useDispatchAreaStore();
    const streamListener = useMemo(() => {
        const streamListener = createStreamListener({
            streamNames: ['responsePlanNotifications'],
            onMessage(message) {
                if (isWeb || electronBridge?.args['--workspace-window-type'] === 'EVENT_V2') {
                    if (
                        dispatchAreasStore
                            .getMonitoredAndOwnedDispatchAreaIds()
                            .find(
                                (dispatchAreaId) =>
                                    dispatchAreaId === message.payload.dispatchAreaId
                            )
                    ) {
                        toast({
                            status: 'default',
                            description: `New Unit Recommendations for Event #${message.payload.agencyEventNumber}`,
                            action: {
                                children: 'Dispatch Recommended Units',
                                onClick() {
                                    drawerControls.open({
                                        type: 'manage-units',
                                        props: {
                                            eventId: message.payload.agencyEventId,
                                        },
                                    });
                                },
                            },
                        });
                    }
                }
            },
        });
        return streamListener;
    }, [dispatchAreasStore, drawerControls, toast, isWeb]);
    useStream(streamListener);
    return null;
}
